import type { RouteObject } from 'react-router';
import { NotFoundPage } from '@/app/system-pages';
import { lazyNamed } from '@/lib/lazy';
import { acquisitionsRoutes } from './acquisitions/routes';
import { adminRoutes } from './admin/routes';
import { catalogRoutes } from './catalog/routes';
import { circulationRoutes } from './circulation/routes';
import { collectionsRoutes } from './collections/routes';
import { finesRoutes } from './fines/routes';
import { kohaImportRoutes } from './koha-import/routes';
import { kioskRoutes, opacAuthRoutes, opacRoutes } from './opac/routes';
import { patronsRoutes } from './patrons/routes';
import { reportsRoutes } from './reports/routes';
import { serialsRoutes } from './serials/routes';
import { servicesRoutes } from './services/routes';
import { toolsRoutes } from './tools/routes';

const DashboardPage = lazyNamed(() => import('./dashboard/DashboardPage'), 'DashboardPage');

/**
 * Every feature owns its route module (features/<name>/routes.tsx) and exports RouteObject[].
 * This file only aggregates them: add a line here when a new feature folder appears, nothing else.
 *
 * Staff routes live under /staff (StaffShell, requires a staff session). Public OPAC routes sit under "/"
 * (PublicShell). Auth screens and the kiosk have their own frames.
 */
export const staffRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  ...circulationRoutes,
  ...catalogRoutes,
  ...serialsRoutes,
  ...collectionsRoutes,
  ...patronsRoutes,
  ...finesRoutes,
  ...acquisitionsRoutes,
  ...servicesRoutes,
  ...reportsRoutes,
  ...toolsRoutes,
  ...adminRoutes,
  ...kohaImportRoutes,
  { path: '*', element: <NotFoundPage inShell /> },
];

export const publicRoutes: RouteObject[] = [...opacRoutes, { path: '*', element: <NotFoundPage inShell /> }];
export const authRoutes: RouteObject[] = opacAuthRoutes;
export const kioskChildRoutes: RouteObject[] = kioskRoutes;
